"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _Icon = _interopRequireDefault(require("@ui-kit.next/core/Icon"));

var getColor = function getColor(_ref) {
  var $color = _ref.$color;
  return $color && (0, _styledComponents.css)(["color:", ";"], $color);
};

var StyledIcon = (0, _styledComponents["default"])(_Icon["default"]).withConfig({
  displayName: "Icon__StyledIcon",
  componentId: "ttu7ny-0"
})(["width:", ";height:", ";flex-shrink:0;", ""], function (_ref2) {
  var theme = _ref2.theme,
      $size = _ref2.$size;
  return theme.components.icon.size[$size];
}, function (_ref3) {
  var theme = _ref3.theme,
      $size = _ref3.$size;
  return theme.components.icon.size[$size];
}, getColor);
var _default = StyledIcon;
exports["default"] = _default;